
<div class="main">

  <div class="presentation" data-aos="fade-down" data-aos-duration="1500">
    <h2>
        Our Makeathon
    </h2>
    <p>
      One of the most important axis of our event as it requires from young engineers to put their soft and hard skills to the test.
      Challengers will be given the opportunity to think beyond limits and showcase their creativity and efficiency in solving modern problems.
      This opportunity will not only  broaden their knowledge through collaborating with others but also improve their public speaking skills through pitching to promote their solution.
    </p>
</div>

    <div class="container">
        <div class="row">
          <div class="col">
            <div class="main-timeline">
              <div class="timeline">
                <div data-aos="fade-left" data-aos-duration="1500" class="timeline-content">
                  <div class="timeline-icon">
                    <i class="fa fa-clock"></i>
                  </div>
                  <div class="content">
                    <h3 class="title">36h competition</h3>
                    <p class="description">
                     participants are given a fixed time to work on problems given and come up with their own solutions
                    </p>
                  </div>
                </div>
              </div>
              <div class="timeline">
                <div data-aos="fade-right" data-aos-duration="1500" class="timeline-content">
                  <div class="timeline-icon">
                    <i class="fa fa-users" aria-hidden="true"></i>
                  </div>
                  <div class="content">
                    <h3 class="title">Teams</h3>
                    <p class="description">
                     One of our main purposes is to encourage people to engage in collaborative work as team work it's a fondamental skill to have in our domain.
                    </p>
                  </div>
                </div>
              </div>
              <div class="timeline">
                <div data-aos="fade-left" data-aos-duration="1500" class="timeline-content">
                  <span class="timeline-year"></span>
                  <div class="timeline-icon">
                    <i class="fa-solid fa-chalkboard-user"></i>
                      </div>
                  <div class="content">
                    <h3 class="title">Mentors</h3>
                    <p class="description">
                      Teams will be guided by mentors from different companies to ensure the good proceedings of their work.
                    </p>
                  </div>
                </div>
              </div>
              <div class="timeline">
                <div data-aos="fade-right" data-aos-duration="1500" class="timeline-content">
                  <span class="timeline-year"></span>
                  <div class="timeline-icon">
                   <i class="fa-solid fa-list-check"></i>
                  </div>
                  <div class="content">
                    <h3 class="title">Prototypes & 
                      specifications</h3>
                    <p class="description">
                     To further more facilitate the procedure , participants will be given all the details needed and prototypes to have a clearer idea on the subject at hand
                    </p>
                  </div>
                </div>
              </div>
              <div class="timeline">
                <div data-aos="fade-left" data-aos-duration="1500" class="timeline-content">
                  <span class="timeline-year"></span>
                  <div class="timeline-icon">
                    <i class="fa-solid fa-person-chalkboard"></i>
                  </div>
                  <div class="content">
                    <h3 class="title">Pitching</h3>
                    <p class="description">
                     Each team will chose a representative to explain the solution they think is optimal and worked on throught the competition time.
                    </p>
                  </div>
                </div>
              </div>
              <div class="timeline">
                <div data-aos="fade-right" data-aos-duration="1500" class="timeline-content">
                  <span class="timeline-year"></span>
                  <div class="timeline-icon">
                    <i class="fa-solid fa-award"></i>
                  </div>
                  <div class="content">
                    <h3 class="title">Winners</h3>
                    <p class="description">
                    Winners will be announced in the closing ceremony where they will be handed their well earned prizes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>   
    <div  class="block" style="background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.367), rgb(26, 4, 20)),
url(../../../assets/background/Hackathon/1.jpg );" >
   <div class="content" >
      <p class="counter" data-aos-duration="1000" data-aos="fade-right" > About NRW 3.1 Hackathon</p>
<p class="def" style=" background-size: cover;" data-aos-duration="1500" data-aos="fade-right" > 
  Last edition’s hackathon was, a 36 hours competition, in partnership with <span>TELNET</span> and under the patronage of the ministry of logistics and transport that puts to test the participants abilities and skills in the fields of IOT and robotics, which were used to solve a real-life problem in the transport field. And as a reward, the winners were offered up to 5000dt in total.
   </p>
   </div>
</div>
</div>
